import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Layer_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 2323.9 909.6"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode(".st0{fill-rule:evenodd;clip-rule:evenodd;fill:#cc2229}")
      ])),
      _: 1
    })),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      d: "M739.7 883.7 502.7 440 715 26H435L289.2 391.1h-3.9v2.3l2.6-2.3h-1.3 1.3V26H22.2v857.7h265.6V490.1h2.6-1.3l165.4 393.6z",
      class: "st0"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M1570.2 883.7 1768.1 26H1509l-58.6 345.8c-11.7 67.1-14.3 133.1-22.1 186.6h-2.6c-10.4-62.6-18.3-124-30-186.6L1327.9 26H1100l-69 345.8c-13 63.7-14.3 126.3-22.1 190h-2.6c-9.1-63.7-16.9-126.3-27.3-190L920.4 26H658.7l218.7 857.7h257.8l56-348.1c11.7-69.4 14.3-129.7 20.8-188.8h2.6c9.1 59.2 13 119.5 27.3 188.8l71.6 348.1zm719.7-852.1c-43-14.8-88.5-20.5-135.4-20.5-128.9 0-431 64.8-431 449.4 0 293.5 184.9 438 402.4 438 58.6 0 106.8-10.2 160.2-30.7l15.6-240c-43 34.1-80.8 54.6-140.6 54.6-132.8 0-166.7-127.4-166.7-227.5 0-94.4 33.9-227.6 171.9-227.6 54.7 0 86 18.2 123.7 50.1z",
      class: "st0"
    }, null, -1))
  ]))
}
export default { render: render }